import { render, staticRenderFns } from "./AnswerListTableRow.vue?vue&type=template&id=2caa8e95&scoped=true&"
import script from "./AnswerListTableRow.vue?vue&type=script&lang=js&"
export * from "./AnswerListTableRow.vue?vue&type=script&lang=js&"
import style0 from "./AnswerListTableRow.vue?vue&type=style&index=0&id=2caa8e95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa8e95",
  null
  
)

export default component.exports